import GroupedListReducer from '../GroupedListReducer.js';
const apiAccessKeyReducer = GroupedListReducer.create({
  name: 'apiAccessKey',
  namePlural: 'apiAccessKeys',
  idKey: 'id',
  idActionKey: 'apiAccessKeyId',
  constantPrefix: 'api.apiAccessKey',
  itemKey: 'apiAccessKey',
  itemsKey: 'items',
  defaultStateKey: 'apiAccessKeys',
  offsetKey: 'startIndex',
  limitKey: 'perPage',
  countKey: 'total'
});
const selectors = apiAccessKeyReducer.createSelectors('apiAccessKeys', true);
Object.keys(selectors).forEach(key => {
  apiAccessKeyReducer[key] = selectors[key];
});
export default apiAccessKeyReducer;